import { render, staticRenderFns } from "./room-beauty-dialog.vue?vue&type=template&id=6cf0fb82&scoped=true&lang=pug&"
import script from "./room-beauty-dialog.vue?vue&type=script&lang=js&"
export * from "./room-beauty-dialog.vue?vue&type=script&lang=js&"
import style0 from "./room-beauty-dialog.vue?vue&type=style&index=0&id=6cf0fb82&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf0fb82",
  null
  
)

/* custom blocks */
import block0 from "./room-beauty-dialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports